import { InjectionToken } from '@angular/core';

import { environment } from '../../../environments/environment';
import { GoogleMapAdapter } from './google-map.adapter';
import { LeafletMapAdapter } from './leaflet-map.adapter';
import { MapAdapter, MapProvider } from './map-adapter';

/**
 * The implementation of the seam for a provider name. Google Maps is the default (decided
 * 2026-10-21, the same choice as Android #114: free below 10,000 map loads a month, the native
 * SDK free on Android); Leaflet + MapTiler stays the configured fallback for when the loads
 * outgrow the free tier or the consent story under #171 asks for an EU provider.
 */
export function createMapAdapter(provider: MapProvider): MapAdapter {
  return provider === 'leaflet' ? new LeafletMapAdapter() : new GoogleMapAdapter();
}

/** The map library in use — `environment.map.provider` decides; a spec provides a fake. */
export const MAP_ADAPTER = new InjectionToken<MapAdapter>('MAP_ADAPTER', {
  providedIn: 'root',
  factory: () => createMapAdapter(environment.map.provider),
});
